class SuggestionSource {
    constructor(API) {
        this.API = API;
    }

    async list(data) {
        return await this.API.get('/index.php?route=api/geo/suggest', {
            params: data
        })
    }

}


export default SuggestionSource
